import { ElementRef, inject, Injectable } from "@angular/core";
import { HomePageFeature } from "src/app/common/models/home-page.model";
import { MultiPillarboxService } from "src/app/common/services/pillarbox-multi.service";

@Injectable({ providedIn: "root" })
export class PillarboxService {
  private readonly multiPillarboxService = inject(MultiPillarboxService);
  private readonly playerId = "default-player";

  dispose(): void {
    this.multiPillarboxService.dispose(this.playerId);
  }

  disposePlayer(): void {
    this.multiPillarboxService.disposePlayer(this.playerId);
  }

  disposeDialog(): void {
    this.multiPillarboxService.disposeDialog(this.playerId);
  }

  hasPlayer(): boolean {
    return this.multiPillarboxService.hasPlayer(this.playerId);
  }

  initPlayer(container: ElementRef, audioOnlyMode: boolean): void {
    this.multiPillarboxService.initPlayer(this.playerId, container, audioOnlyMode);
  }

  initOrSetSource(source: string, container?: ElementRef, audioOnlyMode?: boolean): void {
    this.multiPillarboxService.initOrSetSource(this.playerId, source, container, audioOnlyMode);
  }

  get currentTime(): number {
    return this.multiPillarboxService.getCurrentTime(this.playerId);
  }

  set currentTime(value: number) {
    this.multiPillarboxService.setCurrentTime(this.playerId, value);
  }

  get paused(): boolean {
    return this.multiPillarboxService.paused(this.playerId);
  }

  pause(): void {
    this.multiPillarboxService.pause(this.playerId);
  }

  async play(): Promise<void> {
    await this.multiPillarboxService.play(this.playerId);
  }

  setSource(source: string): void {
    this.multiPillarboxService.setSource(this.playerId, source);
  }

  openDialogWithVideo(feature: HomePageFeature, videoTime?: number): void {
    this.multiPillarboxService.openDialogWithVideo(feature, videoTime);
  }
}
